import { render, staticRenderFns } from "./FormFields.vue?vue&type=template&id=67fe4634&scoped=true"
import script from "./FormFields.vue?vue&type=script&lang=js"
export * from "./FormFields.vue?vue&type=script&lang=js"
import style0 from "./FormFields.vue?vue&type=style&index=0&id=67fe4634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fe4634",
  null
  
)

export default component.exports